export default "__VITE_ASSET__Ixuqh8tZ__"